import { render, staticRenderFns } from "./draw-lots.vue?vue&type=template&id=3d124f4d&scoped=true"
import script from "./draw-lots.vue?vue&type=script&lang=js"
export * from "./draw-lots.vue?vue&type=script&lang=js"
import style0 from "./draw-lots.vue?vue&type=style&index=0&id=3d124f4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d124f4d",
  null
  
)

export default component.exports